import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { AuthenticationManagerService, AuthenticationMethod } from '@technocom/auth';
import { AuthenticationMethodResolvedData, DomainPageComponent } from '@technocom/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginPageComponent extends DomainPageComponent {
  constructor(currentRoute: ActivatedRoute, private service: AuthenticationManagerService) {
    super(currentRoute);
  }

  methods$: Observable<AuthenticationMethod[]>;

  protected onInit(): void {
    super.onInit();

    this.methods$ = this.route.data.pipe(
      filter((routeData: Data) => routeData.loginBy instanceof Object),
      map((routeData: Data) => {
        const loginBy = routeData.loginBy as AuthenticationMethodResolvedData;

        return loginBy.methodCode ? [loginBy.method] : this.service.getEnabledLoginMethods();
      }),
    );
  }
}
